/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */
import { getIsControlTransportToOpt } from '../api/carSchedulingDialog';
import { getTsOrdersApi, pullDownTipsApi, pullDownOrderCheckTipsApi, getTasksByTaskNosApi } from '../api/dispatchCenter';
import { Message, MessageBox } from 'element-ui';

export const groupPolicyObj = [
    {
        code: 'customerCode',
        name: 'customerName'
    },
    {
        code: 'networkCode',
        name: 'networkName'
    },
    {
        code: 'receiverCityCode',
        name: 'receiverCityName'
    },
    {
        code: 'receiverDistrictCode',
        name: 'receiverDistrictName'
    },
    {
        code: 'receiverProvinceCode',
        name: 'receiverProvinceName'
    },
    {
        code: 'receiverTownCode',
        name: 'receiverTownName'
    },
    {
        code: 'siteCode',
        name: 'siteName'
    },
    {
        code: 'senderCityCode',
        name: 'senderCityName'
    },
    {
        code: 'senderDistrictCode',
        name: 'senderDistrictName'
    },
    {
        code: 'senderProvinceCode',
        name: 'senderProvinceName'
    }
];

export const smartCarIsShow = true;
// 两数组是否相同
export function judgeResultFun (arrOne, arrTwo) {
    let flag = true;
    if (arrOne.length !== arrTwo.length) {
        flag = false;
    } else {
        arrOne.forEach(item => {
            if (arrTwo.indexOf(item) === -1) {
                flag = false;
            }
        });
    }
    return flag;
};
export const rowCarCheck = (checkData, firstTargetData, targetData = []) => {
    if (!firstTargetData) firstTargetData = checkData[0];
    for (let i = 0; i < checkData.length; i++) {
        // if (checkData[i].planOrderFlagName !== firstTargetData.planOrderFlagName) return '模糊订单和非模糊订单不能同时排车';
        if (+checkData[i].planOrderFlag === 1) {
            if (checkData[i].inOutType !== firstTargetData.inOutType) return '模糊订单只支持同类型单据排车';
        } else {
            if (
                (!['OUT', 'YS'].includes(firstTargetData.inOutType) && checkData[i].inOutType !== firstTargetData.inOutType) ||
                (['OUT', 'YS'].includes(firstTargetData.inOutType) && !['OUT', 'YS'].includes(checkData[i].inOutType))
            ) return '非模糊订单只支持 同类型 或 纯运输和销售出库类 订单排车';
        }
        if (!['OUT', 'YS'].includes(firstTargetData.inOutType)) {
            if (checkData[i].warehouseGroup !== firstTargetData.warehouseGroup) return '存在不同仓库分组的运输单';
        }
    }
    const allTargetData = [...checkData, ...targetData];
    const outArr = allTargetData.filter(item => item.inOutType === 'OUT');
    for (let i = 0; i < outArr.length; i++) {
        if (outArr.length && outArr[i].warehouseGroup !== outArr[0].warehouseGroup) return '存在不同仓库分组的销售出库单';
    }
    if (allTargetData.some(item => { return item.projectClassify === 'QCO'; }) && !allTargetData.every(item => { return item.projectClassify === 'QCO'; })) {
        return '快销订单不允许与其他订单混排！';
    }
    if (allTargetData.some(item => { return +item.freightBasis === 40; }) && !allTargetData.every(item => { return +item.freightBasis === 40; })) {
        return '搬仓订单与非搬仓订单不允许混排！';
    }
    if (!allTargetData.every(v => v.sourceSystem === 'LONGI-WBKH') && allTargetData.some(v => v.sourceSystem === 'LONGI-WBKH')) {
        return '隆基订单不允许与其他客户订单混排，请重新选择！';
    }
    if (allTargetData.every(v => v.sourceSystem === 'LONGI-WBKH') && [...new Set(allTargetData.filter(v => v.platformOrderNo).map(v => v.platformOrderNo))].length > 1) {
        return '隆基客户单次排车仅允许选择一个平台单号，请重新选择！';
    }
    return '';
};
export const addOrderCheck = (totalTargetData, checkData) => {
    // 加单的仓库分组校验 OUT的仓库分组要一致
    const dispatchNoData = totalTargetData.filter(item => item.dispatchNo); // 下面已经生成的发车单
    let outSameWarehouseGroupCount = 0;
    if (dispatchNoData.length > 0) {
        const outOrderData = dispatchNoData.filter(item => item.inOutType === 'OUT');
        if (outOrderData.length > 0) {
            outOrderData.forEach(o => {
                if (o.warehouseGroup !== outOrderData[0].warehouseGroup) ++outSameWarehouseGroupCount;
            });
            if (outSameWarehouseGroupCount) {
                return '存在不同仓库分组的销售出库单，不能进行加单';
            } else {
                const outSameWarehouseGroup = outOrderData[0].warehouseGroup;
                const allOutData = checkData.filter(item => item.inOutType === 'OUT');
                for (let i = 0; i < allOutData.length; i++) {
                    if (allOutData[i].warehouseGroup !== outSameWarehouseGroup) {
                        return '存在不同仓库分组的销售出库单，不能进行加单';
                    }
                }
            }
        }
    }
    return '';
};
const getLbxObj = (arr) => { // 天猫优品单 customerOrderNo -> isFull 的映射
    const lbxObj = {};
    for (const order of arr) {
        const uniqueKey = order.customerOrderNo;
        if (lbxObj[uniqueKey]) continue;
        lbxObj[uniqueKey] = {
            isFull: order.isFull
        };
    }
    return lbxObj;
};
const getUnCheckObj = (lbxObj, totalData) => {
    const noIsFull = [];
    const unCheckObj = {
        noIsFull: []
    };
    Object.keys(lbxObj).forEach(lbxOrderKey => {
        totalData.forEach(item => {
            if (item.customerOrderNo === lbxOrderKey) {
                if (!item.isFull) {
                    noIsFull.push(item.customerOrderNo);
                }
            }
        });
    });
    unCheckObj.noIsFull = [...new Set(noIsFull)];
    return unCheckObj;
};
const checkOkData = (lbxObj, totalData) => { // 拿出所有天猫优品的单
    const lbxCheckOkData = [];
    Object.keys(lbxObj).forEach(lbxOrderKey => {
        totalData.forEach(item => {
            if (item.customerOrderNo === lbxOrderKey) {
                lbxCheckOkData.push(item);
            }
        });
    });
    return lbxCheckOkData;
};
/**
 *
 * @param { 勾选的单 } checkData
 * @param { 真实的所有的单 } totalData
 */
export const verifyLBX = (checkData, totalData) => { // 往下加单时候的方法
    // 不是LBX订单
    const nolbxOrders = checkData.filter(item => !(item.businessMode === 'B2B' && ['OUT', 'DO'].includes(item.taskType) && item.sourceSystem === 'CAINIAO'));
    // LBX订单
    const lbxOrders = checkData.filter(item => item.businessMode === 'B2B' && ['OUT', 'DO'].includes(item.taskType) && item.sourceSystem === 'CAINIAO');
    const lbxObj = getLbxObj(lbxOrders); // 客户订单号去重的LBX单
    const unCheckObj = getUnCheckObj(lbxObj, totalData); // 不满足条件的LBX单
    if (unCheckObj.noIsFull.length > 0) {
        return unCheckObj;
    } else {
        return checkOkData(lbxObj, totalData).concat(nolbxOrders); // LBX单满足条件时，整单下拉，要带上不是LBX的勾选的单
    }
};

export const verifyLBXOrder = (checkData) => { // 勾选的单进行右上角按钮操作，查找LBX单，用于不满足要求时给出提示
    const noIsFull = [];
    const unCheckObj = {
        noIsFull: []
    };
    // LBX订单
    const lbxOrders = checkData.filter(item => item.businessMode === 'B2B' && ['OUT', 'DO'].includes(item.taskType) && item.sourceSystem === 'CAINIAO');
    if (lbxOrders) {
        for (const order of lbxOrders) {
            if (!order.isFull) noIsFull.push(order.customerOrderNo);
        }
    }
    unCheckObj.noIsFull = [...new Set(noIsFull)];
    return unCheckObj;
};

export const getMesTip = (verifyLBXRes, _this) => {
    const { noIsFull } = verifyLBXRes;
    if (noIsFull.length > 0) {
        const mes = `<div>
                <div style='color: #F56C6C;'>客户订单号：${noIsFull.join(',')}没有整单下发，请在OTP任务中心做下发</div>
            </div>`;
        return messageTip(_this, mes);
    }
};
const messageTip = (_this, mes) => {
    return _this.$message({
        type: 'warning',
        duration: 5000,
        dangerouslyUseHTMLString: true,
        message: mes,
        showClose: true
    });
};
export const minusVerifyLBXOrder = (checkData, totalData) => { // 往上减单时，找到LBX单，将对应的整单全部移上去,转移也可以用此方法
    // 不是LBX订单
    const nolbxOrders = checkData.filter(item => !(item.businessMode === 'B2B' && ['OUT', 'DO'].includes(item.taskType) && item.sourceSystem === 'CAINIAO'));
    // LBX订单
    const lbxOrders = checkData.filter(item => item.businessMode === 'B2B' && ['OUT', 'DO'].includes(item.taskType) && item.sourceSystem === 'CAINIAO');
    const lbxObj = getLbxObj(lbxOrders); // 客户订单号去重的LBX单
    return checkOkData(lbxObj, totalData).concat(nolbxOrders);
};
/**
 *@description 判断直控运力订单使用非直控司机，原因填写
 * @param {Object} dispatchData //发车单
 * @param {Array} totalTasksData  //运输单集合
 * @returns 布尔值
 */
export const lineOperationCheck = async (dispatchData, totalTasksData) => {
    // 发车单存在直控原因标识directlyControl，无需再填原因
    if (dispatchData.directControlFlag) return false;

    const isDirectControlFlag = totalTasksData.some(i => +i.directControlFlag === 1);
    // 运输单中不存在直控运单单据，不需要填写原因
    if (!isDirectControlFlag) return false;

    let flag = false;
    await getIsControlTransportToOpt({ supplierCode: dispatchData.carrierCode }).then(res => {
        if (res && +res.code === 0) {
            flag = !res.data.isControlTransport;
        }
    });
    return flag;
};

export const dispatchCenterRowCarCheck = (checkData, firstTargetData, targetData = []) => {
    if (!firstTargetData) firstTargetData = checkData[0];
    for (let i = 0; i < checkData.length; i++) {
        // if (checkData[i].planOrderFlagName !== firstTargetData.planOrderFlagName) return '模糊订单和非模糊订单不能同时排车';
        if (!['OUT', 'YS'].includes(firstTargetData.inOutType)) {
            if (checkData[i].warehouseGroup !== firstTargetData.warehouseGroup) return '存在不同仓库分组的运输单';
        }
    }
    const outArr = (targetData.concat(checkData)).filter(item => item.inOutType === 'OUT');
    for (let i = 0; i < outArr.length; i++) {
        if (outArr.length && outArr[i].warehouseGroup !== outArr[0].warehouseGroup) return '存在不同仓库分组的销售出库单';
    }
    if (targetData.concat(checkData).some(item => { return item.projectClassify === 'LW'; }) && !targetData.concat(checkData).every(item => { return item.projectClassify === 'LW'; })) {
        return '菱王电梯的订单不允许与其他客户的订单混排！';
    }
    // 强制预约时，必须都有预约时间才能加单
    const arriveAppointmentRequireCheck = [...targetData, ...checkData].some(row => +row.arriveAppointmentRequireFlag === 2 && !row.appointmentTime);
    if (arriveAppointmentRequireCheck) {
        return '存在强制预约的客户订单，需要预约派送时间!';
    }
    if (targetData.concat(checkData).some(item => { return item.projectClassify === 'QCO'; }) && !targetData.concat(checkData).every(item => { return item.projectClassify === 'QCO'; })) {
        return '快销订单不允许与其他订单混排！';
    }
    return '';
}

const copyText = (copyText) => {
    if (!copyText) return;
    var input = document.createElement('input');
    input.type = 'text';
    input.value = copyText.trim();
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    Message.success(`‘${input.value}’复制成功`);
};
/**
 * 判断强制预约
 * @param {*} dataList 需要校验的tk单集合
 * @param {*} appointmentSiteCodeWhiteList  服务平台白名单
 * @returns
 */
export const appointmentCheck = (dataList, appointmentSiteCodeWhiteList) => {
    let newDataList = [];
    let eliminateArr = [];
    if (appointmentSiteCodeWhiteList[0] === 'ALL') { // ALL等于所以服务平台都走白名单
        newDataList = dataList.filter(v => +v.arriveAppointmentRequireFlag === 3 && +v.appointmentFlag !== 1);
    } else {
        // 白名单下的服务平台,且是否要求前置预约=是 & 是否预约=否
        newDataList = dataList.filter(v => appointmentSiteCodeWhiteList.includes(v.siteCode) && +v.arriveAppointmentRequireFlag === 3 && +v.appointmentFlag !== 1);
    }
    eliminateArr = [...new Set(newDataList.map(v => v.customerOrderNo))];// 获取去重后的客户订单号
    return eliminateArr;
};
const getTsOrders = async (tsOrderNos, dispatchNoList, that) => {
    const res = await getTsOrdersApi({
        tsOrderNoList: tsOrderNos,
        dispatchNoList,
        carrierVisibleFlag: 'Y',
        carrierCode: that.$store.state.supplier.supplierCode
    });
    if (res && +res.code === 0) {
        const transportList = res.data.transportList || [];
        const associationDispatchNoList = res.data.associationDispatchNoList || [];
        const checkMsg = res.data.checkMsg || '';
        if (checkMsg) {
            Message({
                dangerouslyUseHTMLString: true,
                message: `<div>
                        <span>${checkMsg}</span>
                        <a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                    </div>`,
                showClose: true,
                type: 'warning',
                duration: 5000
            });
            document.getElementById('copyTraNo').addEventListener('click', () => {
                copyText(associationDispatchNoList.join(','));
            });
        }
        return transportList;
    }
};
/**
 * 获取选中值中的套车编码集合
 * @param {Array} arr 需要过滤的数组
 * @param {string} tsOrderNo 过滤的标识，套车编码
 * @returns {Array} 去重后的非空套车编码集合
 */
const getUniqueTsOrderNos = (arr, tsOrderNo) => {
    if(!arr.length) return []
    return [...new Set(arr.flatMap(item => item[tsOrderNo] || []))];
};

/**
 *根据选中的值，包含套车编码获取对应的所有值
 * @param {Array} allDataList  所有TK单的集合
 * @param {Array} selectDataList  选中的TK单的集合
 * @returns {Array}   过滤后的TK单
 */
export const getAllGroupData = async (allDataList, selectDataList, dispatchNoList, flag, that) => {
    const tsOrderNos = getUniqueTsOrderNos(selectDataList, 'tsOrderNo');
    if (!tsOrderNos.length) {
        return selectDataList;
    }
    // 不是套送订单
    const noTsOrderNos = selectDataList.filter(v => !v.tsOrderNo);
    if (flag) {
        const transportList = await getTsOrders(tsOrderNos, dispatchNoList, that);
        return transportList.concat(noTsOrderNos);
    } else {
        return allDataList.filter(i => tsOrderNos.includes(i.tsOrderNo)).concat(noTsOrderNos);
    }
};

// 若发车单多套送订单号排车或者与非套系排车，减单、转移出需关联套送订单号下的任务同时移除；
// 若发车单有且只有一套套送订单号排车，则允许其部分移除
export const moveUpGroupData = async (allDataList, selectDataList, dispatchNoList, that) => {
   // 获取所有的tsOrderNo
    const allTsOrderNos = getUniqueTsOrderNos(allDataList, 'tsOrderNo');
    // 获取选中的tsOrderNo
    const tsOrderNos = getUniqueTsOrderNos(selectDataList, 'tsOrderNo');
    const tsOrderNosLength = allDataList.filter(v => v.tsOrderNo).length;
    if (allTsOrderNos.length === 1 && tsOrderNosLength === allDataList.length) {
        return selectDataList;
    }
    if (!tsOrderNos.length) {
        return selectDataList;
    }
    let allMoveUpTaskList = [];
    await MessageBox.confirm('是否全部移除套送订单号下的运单?', '移除套送单会整套全部移除，若排不下请优先移除非套送单', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
    }).then(async () => {
        allMoveUpTaskList = await getAllGroupData(allDataList, selectDataList, dispatchNoList, false, that);
    }).catch(() => {
        allMoveUpTaskList = selectDataList.filter(v => !v.tsOrderNo);
    });
    return allMoveUpTaskList;
};
export const backwardVerification = (allDataList, that) => {
    // 来源系统：美云销、业务模式：B2B、项目分类：门店退货
    const taskNos = [];
    const senderTownCodes = [];
    const receiverTownCodes = [];
    const taskNoList = allDataList.filter(v => v.sourceSystem === 'OFC' && v.businessMode === 'B2B' && v.projectClassify === 'XB_SHOP_RI');
    taskNoList.forEach(i => {
        taskNos.push(i.taskNo);
        senderTownCodes.push(i.senderTownCode);
        receiverTownCodes.push(i.receiverTownCode);
    });

    const unableTaskNos = allDataList.filter(v => !taskNos.includes(v.taskNo)).map(i => i.taskNo);
    if (taskNos.length) {
        let params = {
            taskNos,
            unableTaskNos,
            senderTownCodes,
            receiverTownCodes,
            carrierVisibleFlag: 'Y',
            carrierCode: that.$store.state.supplier.supplierCode
        }
        pullDownTipsApi(params).then(res => {
            if (res && +res.code === 0 && res.data) {
                Message.warning(res.data);
            }
        });
    }
};

// 加单提示
export const moveUpOrderTip = (allDataList, dispatchNo, that) => {
    const newTaskList = allDataList.map(v => {
        const { taskNo, customerOrderNo, customerTotalQty, siteCode, inOutType, orderType, totalQty } = v;
        return {
            taskNo, customerOrderNo, customerTotalQty, siteCode, inOutType, orderType, totalQty
        };
    });
    const params = {
        carrierCode: that.$store.state.supplier.supplierCode,
        dispatchNo,
        poolTransportList: newTaskList
    };
    pullDownOrderCheckTipsApi(params).then(res => {
        if (res && +res.code === 0 && res.data) {
            Message.warning(res.data);
        }
    });
};
/**
 * 获取需要转移的运输单（按completeSetNo分组，分拨最后一段）
 * @param {Array} allTasks 所有运输单
 * @param {Array} selectedTasks 选中的要转移的运输单
 * @returns {Array} 需要转移的运输单
 */
export function getTransferTasksByCompleteSetNo(allTasks, selectedTasks) {
    // 1. 找出勾选中有completeSetNo的运输单
    const checkedWithSetNo = selectedTasks.filter(t => t.distributionLastFlag === 'Y' && t.completeSetNo);
    if (!checkedWithSetNo.length) {
        return selectedTasks;
    }
    // 2. 统计所有勾选中的套送号
    const setNoMap = {};
    checkedWithSetNo.forEach(task => {
        if (!setNoMap[task.completeSetNo]) setNoMap[task.completeSetNo] = [];
        setNoMap[task.completeSetNo].push(task);
    });
    let result = [];
    Object.keys(setNoMap).forEach(setNo => {
        // 找到allTasks中【套送号】、【服务平台】、【预约时间】一致的所有运输单
        const first = setNoMap[setNo][0];
        const isAllSame = allTasks.filter(
            t => t.completeSetNo === first.completeSetNo &&
                     t.siteCode === first.siteCode &&
                     t.appointmentTime === first.appointmentTime
        );
        result = result.concat(isAllSame);
    });
    const checkedWithoutSetNo = selectedTasks.filter(t => (t.distributionLastFlag !== 'Y' || !t.completeSetNo));
    Message.warning('本次减单操作中包含存在套送号的运输单，相同套送号的运输单会自动一起减去');
    return result.concat(checkedWithoutSetNo);
}

/**
 * @param {Array} selectedTasks 选中的运输单
 * @param {String} orderPoolFlag 订单池标识,调度中心新不填，调度中心线路必填MANUAL
 * @returns {Promise<Array>} 处理后的运输单集合
 */
export async function getFinalTasks(selectedTasks, orderPoolFlag = '') {
    // 1. 找出最后一段分拨且有套送号的运输单
    const lastWithSetNo = selectedTasks.filter(
        t => t.distributionLastFlag === 'Y' && t.completeSetNo
    );
    if (!lastWithSetNo.length) {
        return selectedTasks;
    }
    // 2. 取出这些运输单的 taskNo
    const taskNoList = lastWithSetNo.map(t => t.taskNo);
    // 3. 不是最后一段分拨或没有套送号的运输单
    const others = selectedTasks.filter(
        t => t.distributionLastFlag !== 'Y' || !t.completeSetNo
    );
    const params = {
        taskNos: taskNoList,
        orderPoolFlag: orderPoolFlag,
        carrierCode:lastWithSetNo[0].carrierCode
    };
    let result = [];

    try {
        // 4. 调用接口获取后端返回的运输单
        const res = await getTasksByTaskNosApi(params);
        if (res && +res.code === 0 && res.data && res.data.list) {
            result = res.data.list.concat(others);
        } else {
            result = others;
        }
    } catch (error) {
        // 捕获接口异常
        Message.error('接口请求异常，获取同套运输单失败');
        result = [];
    }
    Message.warning('本次加单操作中包含存在套送号的运输单，相同套送号的运输单会自动一起加单');
    return result;
}

/**
 * @param {Array} selectedTasks 选中的运输单
 * @param {String} tip 提示文案
 */
export function showHasSetNoTip (selectedTasks, tip) {
    if (!selectedTasks.length) return;
    const checkedWithSetNo = selectedTasks.filter(t => t.distributionLastFlag === 'Y' && t.completeSetNo);
    if (checkedWithSetNo.length) {
        setTimeout(() => {
            Message.warning(tip);
        }, 100);
    }
}

// 排序，时效优先标识运输单优先拍到前面 timePriority === '1'
export const sortTaskList = (taskList) => {
    taskList.sort((a, b) => {
        // 将timePriority为"1"的对象排在最前面,时效优先标识
        if (+a.timePriority === 1) return -1;
        if (+b.timePriority === 1) return 1;
        // 对于其他对象，保持原来的顺序
        return 0;
    });
    return taskList;
};
